import Service from "../../../Services/index";
import moment from "moment";

const PromotionOther = {
    namespaced: true,
    state: {
        promotion_other_list :[],
        form:{
            id : "",
            sales : [],
            customers : [],
            products : [],
            product_id : [],
            name : "",
            active : 1,
            max_discount : "",
            quantity_pay_all : '',
            pay_all : '',
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
    },
    mutations: {
        GET_PROMOTION_OTHER_LIST : (state,res)=>{
            state.promotion_other_list = res.data;
        },
        GET_PROMOTION_OTHER_FORM :(state,res)=>{
            state.form = res;
        },
        CLEAR_DATA : (state)=>{
            state.form  = {
                id : "",
                sales : [],
                customers : [],
                products : [],
                product_id : [],
                name : "",
                active : 1,
                max_discount : "",
                quantity_pay_all : '',
                pay_all : '',
            }
        }
    },
    actions: {
        setPromotionOtherList({commit},page=1){
            return Service.PromotionOther.getPromotionOther(page).then(res=>{
                commit("GET_PROMOTION_OTHER_LIST",res);
            })
        },
        showPromotionOther({commit},id){
            return Service.PromotionOther.showPromotionOther(id).then(res=>{
                commit("GET_PROMOTION_OTHER_FORM",res);
            })
        },
        savePromotionOther({commit},{id,data}){
           if(!id){ //create
               return Service.PromotionOther.createPromotionOther(data)
           }
           else{
               return Service.PromotionOther.updatePromotionOther(id,data)
           }
        },
        deletePromotionOther({commit},id){
            return Service.PromotionOther.deletePromotionOther(id)
        },
        clearData({commit}){
            commit("CLEAR_DATA");
        }
    }
};

export default PromotionOther;
